/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// PAGE : UI KIT : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	uikit: {
		// titles
		'& #content h1': {
			// borderBottom: replacePXinStringWithEM(`1px solid #ccc`),
			background: theme.color.primary.dark.swatch,
			color: theme.color.primary.dark.contrast,
			margin: replacePXinStringWithEM(`50px 0 20px`),
			padding: replacePXinStringWithEM(`10px`),
			'&:first-child': { marginTop: '0' }
		},
		'& #content h2': {
			margin: replacePXinStringWithEM(`20px 0 10px`),
			'&:first-child': { marginTop: '0' }
		},
		'& #content h3': {
			margin: replacePXinStringWithEM(`20px 0 10px`)
		},

		// groups
		'& .group.type-logos': {
			'& .logo': {
				marginRight: pxToEm(20)
			}
		},
		'& .group.type-icons': {
			'& .icon': {
				marginRight: pxToEm(20)
			}
		}
	}
});